import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx } }) =>
          sx({
            '&.MuiFormControlLabel-root:has(.MuiSwitch-root)': {
              m: 0,
            },
            '&.MuiFormControlLabel-labelPlacementStart:has(.MuiSwitch-root)': {
              '.MuiSwitch-root': { ml: 1 },
            },
            '&.MuiFormControlLabel-labelPlacementEnd:has(.MuiSwitch-root)': {
              '.MuiSwitch-root': { mr: 1 },
            },
            '&.MuiFormControlLabel-labelPlacementEnd, &.MuiFormControlLabel-labelPlacementStart': {
              '.MuiTypography-root': { pt: 0.125 },
              '.MuiSvgIcon-root': { fontSize: 24 },
            },
          }),
      },
    },
    MuiFormLabel: {
      defaultProps: {
        filled: false,
        focused: false,
      },
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx, ...theme } }) =>
          sx({
            ...theme.typography.body2Semibold,
            color: theme.palette.text.primary,
            '.MuiFormLabel-asterisk': {
              color: theme.palette.error.main,
            },
          }),
      },
    },
  },
});

export default theme.components;
